module.exports = __webpack_public_path__ + "img/FI.079f4bcb.svg";